import styled from 'styled-components'

const CountdownSVG = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 200px;
`

export const Styled = { CountdownSVG }
